import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import pakt21ApiUrl from '../common/pakt21ApiUrl';

export function parsePakt21IdQuery(query) {
  const match = String(query || '').trim().match(/^(?:#\s*|id\s+|pakt21\s+)?([0-9]{1,9})$/i);

  if (!match) return null;

  const number = Number(match[1]);
  return Number.isInteger(number) && number >= 1 && number <= 999999999 ? number : null;
}

export default class Pakt21IdSearchSource {
  constructor() {
    this.results = new Map();
  }

  search(query) {
    const number = parsePakt21IdQuery(query);

    if (number === null) {
      this.results.set(query.toLowerCase(), null);
      return Promise.resolve();
    }

    return app.request({
      method: 'GET',
      url: pakt21ApiUrl(app.forum.attribute('apiUrl'), `/pakt21/users/by-number/${number}`),
    })
      .then((payload) => {
        app.store.pushPayload(payload);
        this.results.set(query.toLowerCase(), {
          number,
          user: app.store.getById('users', payload.data.id),
          status: payload.meta?.pakt21Id?.status || 'unknown',
        });
      })
      .catch(() => {
        this.results.set(query.toLowerCase(), null);
      });
  }

  view(query) {
    const result = this.results.get(query.toLowerCase());

    if (!result) return [];

    return [
      <li className="Dropdown-header">{app.translator.trans('pakt21-beta.forum.id_search.heading')}</li>,
      <li className="Pakt21IdSearchResult" data-index={`pakt21-id-${result.number}`}>
        <Link href={`/id/${result.number}`}>
          <strong>PAKT21 ID #{result.number}</strong>
          <span>{result.user.displayName()}</span>
        </Link>
      </li>,
    ];
  }
}
